import Account from "@/helper/AccountHelper.js";
import ConfigManager from "@/config/ConfigManager.js";
import BzbsApi from '@/core/Http/BzbsApi.js';
import CategoryModel from '../model/CategoryModel.js';
import { map } from 'rxjs/operators';

/**
 * @method apiGetCategory
 */

 export default {
     /**
      * @param {Object} categoryParam CategoryConfigModel - /core/Campaign/model/CategoryConfigModel.js
      * @returns {Array.<CategoryModel>}
      */
    apiGetCategory: function (categoryParam) {
        const token = Account.getToken();
        const url = ConfigManager.getApiUrl() + '/campaigncat/menu';
        return BzbsApi.connectBzbsGet(url, token, categoryParam)
            .pipe(map((res) => {
                var categories = [];
                for (var i of res.data) {
                    var category = new CategoryModel(i);
                    categories.push(category);
                }

                return categories;
            }));
    }
 }
